<div class="item cn-up-down">
	<i class="icon cancel">
		<hangup-ico></hangup-ico>
		<span class="counter"><span>{{ node._id_ + 1 }}</span></span>
	</i>
	<div class="name">Завершение вызова</div>
</div>